import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox, DatePicker, Form, Space, Typography } from "antd";
import moment from "moment-timezone";
import styled from "styled-components";

import { SEC_FONT_GREY } from "../../constant/colors";
import { DATE_FORMAT_1 } from "../../utils/date";

const { Text } = Typography;

const StyledFormItem = styled(Form.Item)`
.ant-form-item-explain-error{
  ${(props) => {
    if (!props?.onlyDate) {
      return `
       position: absolute;
       white-space: nowrap;
    `;
    }
  }}
`;

const BillVoidedDateFormItem = ({
  form,
  style,
  editable = true,
  showLabel = false,
  onlyDate = false,
  dataTMId,
  disabled = false,
  defaultDateValue,
  nameDate = "billVoidedDate",
  recordInfo
}) => {
  const { t } = useTranslation();
  const billVoided = Form.useWatch("billVoided", form);
  const billVoidedDate = Form.useWatch("billVoidedDate", form);

  useEffect(() => {
    form.validateFields(["billVoided", "billVoidedDate"]);
  }, [billVoided, billVoidedDate, editable, onlyDate]);

  return (
    <Space style={{ paddingTop: !onlyDate && "5px", width: "100%" }} direction="vertical" size={5}>
      {showLabel && <Text style={{ color: SEC_FONT_GREY }}>{t("form.bill_voided.label")}</Text>}
      <Space direction="horizontal">
        {!onlyDate && (
          <StyledFormItem
            name="billVoided"
            onlyDate={onlyDate}
            style={style}
            valuePropName="checked"
            data-tm-id={dataTMId}
          >
            {!editable && !billVoided ? <></> : <Checkbox disabled={!editable} checked={billVoided} />}
          </StyledFormItem>
        )}

        <StyledFormItem
          name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : nameDate}
          style={style}
          onlyDate={onlyDate}
          rules={[
            {
              validator: async (_, value) => {
                if (!value && billVoided && editable) {
                  return Promise.reject(new Error(`${t("form.bill_voided.date_error_required")}`));
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          {editable ? (
            <DatePicker
              defaultValue={defaultDateValue}
              style={{ minWidth: !onlyDate && "120px", width: "100%" }}
              placeholder={t("form.bill_voided.placeholder_date")}
              disabled={disabled || !editable}
              format={DATE_FORMAT_1}
              allowClear={true}
              data-tm-id={`${dataTMId}-date`}
            />
          ) : (
            <Text data-tm-id={`${dataTMId}-date`}>
              {defaultDateValue ? `${moment(defaultDateValue).format(DATE_FORMAT_1)}` : "-"}
            </Text>
          )}
        </StyledFormItem>
      </Space>
    </Space>
  );
};

export { BillVoidedDateFormItem };
